import { type FC, type PropsWithChildren, useState } from 'react';
import { matchPath, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useTimeout } from 'usehooks-ts';

import { AppRoute } from '@/common/app/routes';
import { useAuthFromTelegram } from '@/common/hooks/auth-from-telegram';
import { useGetMyInfoAfterLogin } from '@/common/hooks/get-my-info-after-login';
import { useAppSelector } from '@/redux/store';

import { DesktopContainer } from '../DesktopContainer/DesktopContainer';
import { FirstLoadScreen } from '../FirstLoadScreen/FirstLoadScreen';

const ProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
  const loginRequestIsLoading = useAppSelector(
    (state) => state.app.loginRequestIsLoading,
  );
  const token = useAppSelector((state) => state.user.token);
  const [isTimeoutEnd, setIsTimeoutEnd] = useState(false);
  useAuthFromTelegram();
  useGetMyInfoAfterLogin();

  const initDataIsExist = !!Telegram?.WebApp?.initData;

  useTimeout(() => {
    setIsTimeoutEnd(true);
  }, 3000);

  const isLoginPage = matchPath(AppRoute.LOGIN, window.location.pathname);

  if (!initDataIsExist && !isLoginPage && !token) {
    const startParam = new URLSearchParams(window.location.search).get(
      'start_param',
    );
    const loginUrl = startParam
      ? `${AppRoute.LOGIN}?start_param=${encodeURIComponent(startParam)}`
      : AppRoute.LOGIN;

    return <Navigate to={loginUrl} replace={true} />;
  }

  return (
    <AnimatePresence mode="sync">
      {loginRequestIsLoading || !isTimeoutEnd ? (
        <DesktopContainer>
          <FirstLoadScreen />
        </DesktopContainer>
      ) : (
        children
      )}
    </AnimatePresence>
  );
};

export { ProtectedRoute };
